import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { saveLastMainRoute } from '@/utils/navigationReturn'

// 类型声明扩展（如果尚未添加）
declare module 'vue-router' {
  interface RouteMeta {
    title?: string    // 页面标题
    requiresAuth?: boolean
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    // 公开静态首页，不展示登录或业务功能入口
    path: '/',
    name: 'public-home',
    component: () => import(/* webpackChunkName: "public-home" */ '../views/PublicHome.vue'),
    meta: {
      title: '编程分享'
    }
  },
  {
    // excel表格
    path: '/excel',
    name: 'excel',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ExcelViewTemp.vue'),
    meta: {
      title: '匠模久 - 模板编辑'
    }
  },
  {
    // 模板社区专用编辑页（使用 ExcelViewMB 布局）
    path: '/excel-mb',
    name: 'excel-mb',
    component: () => import(/* webpackChunkName: "excel-mb" */ '../views/ExcelViewMB.vue'),
    meta: {
      title: '匠模久 - 模板编辑'
    }
  },
  {
    // excel表格
    path: '/project',
    name: 'project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectViewTemp.vue'),
    meta: {
      title: '匠模久 - 项目编辑'
    }
  },
    {
    // excel产品库表格
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductViewTemp.vue'),
    meta: {
      title: '匠模久 - 产品库编辑'
    }
  },
  {
    // 登录
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserLogin.vue'),
    meta: {
      title: '匠模久 - 欢迎'
    }
  },
  {
    // 文件预览
    path: '/preview',
    name: 'preview',
    component: () => import(/* webpackChunkName: "about" */ '../views/FilePreview.vue'),
    meta: {
      title: '文件预览'
    }
  },
  {
    // 分享管理（独立页面）
    path: '/share-management',
    name: 'share-management-standalone',
    component: () => import(/* webpackChunkName: "share" */ '../views/ShareManagement.vue'),
    meta: {
      title: '分享管理 - 匠模久'
    }
  },
  {
    // 账户中心
    path: '/setting',
    name: 'setting',
    component: () => import(/* webpackChunkName: "about" */ '../views/SettingView.vue'),
    meta: {
      title: '账户中心 - 匠模久'
    }
  },
  {
    // 工作空间主页
    path: '/main',
    name: 'main',
    component: () => import(/* webpackChunkName: "about" */ '../views/MainPage.vue'),
    meta: { title: '匠模久 - 工作空间' },
    children: [
      // 默认子路由
      {
        path: '',
        redirect: '/main/formula'
      },
      // 公式页面
      {
        path: 'formula',
        name: 'main-formula',
        component: () => import('@/views/subpages/FormulaTemp.vue'),
        meta: { title: '我的模板' },
      },
      // 项目页面
      {
        path: 'projects',
        name: 'main-projects',
        component: () => import('@/views/subpages/ProjectsView.vue'),
        meta: { title: '我的项目' }
      },
      // 最近公式
      {
        path: 'recent-formula',
        name: 'main-recent-formula',
        component: () => import('@/views/subpages/RecentFormula.vue'),
        meta: { title: '最近模板' }
      },
      // 最近分享
      {
        path: 'recent-shares',
        name: 'main-recent-shares',
        component: () => import('@/views/subpages/RecentShares.vue'),
        meta: { title: '最近分享' }
      },
      // 分享管理
      {
        path: 'share-inbox',
        name: 'main-share-inbox',
        component: () => import('@/views/subpages/ShareInbox.vue'),
        meta: { title: '分享管理' }
      },
      // 产品库
      {
        path: 'ProductLibrary',
        name: 'main-ProductLibrary',
        component: () => import('@/views/subpages/ProductLibrary.vue'),
        meta: { title: '我的产品库' }
      },
      // 模板社区
      {
        path: 'template-community',
        name: 'main-template-community',
        component: () => import('@/views/subpages/TemplateCommunity.vue'),
        meta: { title: '模版社区' }
      },
      // 回收站
      {
        path: 'RecycleBin',
        name: 'RecycleBin',
        component: () => import('@/views/subpages/RecycleBin.vue'),
        meta: { title: '回收站' }
      }
    ]
  },
  {
    // 管理主页
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/MainadminPage.vue'),
    meta: { title: '匠模久 - 管理主页' },
    children: [
      // 默认子路由-用户管理
      {
        path: '',
        redirect: '/admin/user-management'
      },
      // 用户管理
      {
        path: 'user-management',
        name: 'user-management',
        component: () => import('@/views/subpages/UserManagement.vue'),
        meta: { title: '用户管理' },
      },
      // 角色管理
      {
        path: 'role-management',
        name: 'role-management',
        component: () => import('@/views/subpages/RoleManagement.vue'),
        meta: { title: '角色管理' },
      },
      // 权限管理
      {
        path: 'permission-management',
        name: 'permission-management',
        component: () => import('@/views/subpages/PermissionManagement.vue'),
        meta: { title: '权限管理' },
      },
      // 模板类型管理
      {
        path: 'template-type-management',
        name: 'template-type-management',
        component: () => import('@/views/subpages/TemplateTypeManagement.vue'),
        meta: { title: '模板类型管理' },
      },
      // 产品库类型管理
      {
        path: 'product-type-management',
        name: 'product-type-management',
        component: () => import('@/views/subpages/ProductTypeManagement.vue'),
        meta: { title: '产品库类型管理' },
      },
      // 项目类型管理
      {
        path: 'project-type-management',
        name: 'project-type-management',
        component: () => import('@/views/subpages/ProjectTypeManagement.vue'),
        meta: { title: '项目类型管理' },
      },
      // 表格权限管理
      {
        path: 'table-access-management',
        name: 'table-access-management',
        component: () => import('@/views/subpages/TableAccessManagement.vue'),
        meta: { title: '表格权限管理' },
      },
      // 算式管理
      {
        path: 'formula-management',
        name: 'formula-management',
        component: () => import('@/views/subpages/FormulaManagement.vue'),
        meta: { title: '算式管理' },
      },
      // 分享管理
      {
        path: 'share-management',
        name: 'share-management',
        component: () => import('@/views/ShareManagement.vue'),
        meta: { title: '分享管理' },
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局路由守卫处理标题
router.beforeEach((to, from, next) => {
  const defaultTitle = '匠模久 - 专业建模工具'
  const suffix = ' - 匠模久'

  // 公开首页保持纯个人编程分享标题，不拼接业务系统名称。
  if (to.name === 'public-home') {
    document.title = to.meta.title || '编程分享'
  } else if (to.meta.title) {
    document.title = to.meta.title.includes('匠模久')
        ? to.meta.title
        : `${to.meta.title}${suffix}`
  } else {
    document.title = defaultTitle
  }

  next()
})

// 记录工作空间左侧功能栏当前所在页面。
// 编辑页在新标签页中打开时没有 from 路由，返回按钮会读取这个值，
// 避免默认回到“我的模板”。
router.afterEach((to) => {
  if (to.path === '/main' || to.path.startsWith('/main/')) {
    saveLastMainRoute(to.fullPath)
  }
})

export default router
